module.exports = __webpack_public_path__ + "img/vip_customer_icon2.43fc8f13.png";